import { signIn } from '../supabase-client.js';

function authErrorMessage(error) {
  const msg = error?.message ?? '';
  if (msg.includes('Invalid login credentials')) {
    return 'Email o password non corretti.';
  }
  if (msg.includes('Email not confirmed')) {
    return 'Conferma la tua email prima di accedere.';
  }
  return 'Accesso non riuscito. Riprova.';
}

export function renderLogin(container, onSuccess) {
  container.innerHTML = `
    <main class="login-page">
      <div class="login-card">
        <h1 class="login-title">Metis</h1>
        <p class="login-subtitle">Organizza e vivi i tuoi viaggi</p>
        <form class="login-form" id="login-form" novalidate>
          <label class="field">
            <span class="field-label">Email</span>
            <input
              class="field-input"
              type="email"
              name="email"
              autocomplete="email"
              required
              placeholder="nome@esempio.it"
            />
          </label>
          <label class="field">
            <span class="field-label">Password</span>
            <input
              class="field-input"
              type="password"
              name="password"
              autocomplete="current-password"
              required
              minlength="6"
            />
          </label>
          <p class="login-error" id="login-error" role="alert" hidden></p>
          <button class="btn-primary login-submit" type="submit">Accedi</button>
        </form>
      </div>
    </main>
  `;

  const form = container.querySelector('#login-form');
  const errorEl = container.querySelector('#login-error');
  const submitBtn = container.querySelector('.login-submit');

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    errorEl.hidden = true;
    errorEl.textContent = '';

    const formData = new FormData(form);
    const email = String(formData.get('email') ?? '').trim();
    const password = String(formData.get('password') ?? '');

    if (!email || !password) {
      errorEl.textContent = 'Inserisci email e password.';
      errorEl.hidden = false;
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Accesso…';

    try {
      const session = await signIn(email, password);
      onSuccess(session);
    } catch (error) {
      errorEl.textContent = authErrorMessage(error);
      errorEl.hidden = false;
    } finally {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Accedi';
    }
  });
}
